import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export default function convertToSingaporeTime(
  date: Date,
  format: string = "DD/MM/YYYY hh:mma"
): string {
  try {
    // Validate input is a Date object
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      throw new Error("Invalid date format");
    }

    // Format the date to Singapore time with the format: 07/06/2025 12:46pm
    return dayjs(date).tz("Asia/Singapore").format(format);
  } catch (error) {
    console.error(error instanceof Error ? error.message : "Unknown error");
    return "Invalid date";
  }
}

// Test the function
const testDate = new Date("2024-11-23T05:50:14.845Z");
console.log(convertToSingaporeTime(testDate));
